const CALLBACK_NAME = 'gmapsCallback';

// @ts-ignore
let initialized = !!window.google;
// @ts-ignore
let resolveInitPromise;
// @ts-ignore
let rejectInitPromise;

// This promise handles the initialization
// status of the google maps script.
const initPromise = new Promise((resolve, reject) => {
    resolveInitPromise = resolve;
    rejectInitPromise = reject;
});

export default function init() {
    // If Google Maps already is initialized
    // the `initPromise` should get resolved
    // eventually.
    if (initialized) return initPromise;

    initialized = true;
    // The callback function is called by
    // the Google Maps script if it is
    // successfully loaded.
    // @ts-ignore
    window[CALLBACK_NAME] = () => resolveInitPromise(window.google);

    // We inject a new script tag into
    // the `<head>` of our HTML to load
    // the Google Maps script.
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}&callback=${CALLBACK_NAME}&libraries=places&language=ca`;
    // @ts-ignore
    script.onerror = rejectInitPromise;
    // @ts-ignore
    document.querySelector('head').appendChild(script);

    return initPromise;
}
